import React from 'react'
import {Grow, Snackbar} from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import {IGlobalError} from "../../context/GlobalError";

interface IErrorNotificationParams {
  onClose: () => void
  error: IGlobalError
}

const code_names = {
  400: 'Bad request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  408: 'Request Timeout',
  413: 'Request Entity Too Large',
  414: 'Request-URI Too Long',
  415: 'Unsupported Media Type',
  422: 'Unprocessable entity',
  500: 'Internal error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
}

export const GlobalErrorNotification: React.FC<IErrorNotificationParams> = ({onClose, error}) => {
  // @ts-ignore
  const msg = code_names[error?.message] || error?.message || code_names[error?.status] || error?.status

  return (
    <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      open={!!error}
      onClose={onClose}
      autoHideDuration={6000}
      TransitionComponent={Grow}
    >
      <MuiAlert elevation={6} variant="filled" onClose={onClose} severity="error">
        {msg}
      </MuiAlert>
    </Snackbar>
  )
}
